import {
  deletePaymentMethod,
  getAllPaymentMethods,
  newPaymentMethod,
  updatePaymentMethod,
} from '../../services/payment_mehods';

export default {
  /**
   * Get payment methods
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllPaymentMethods({ commit }) {
    const response = await getAllPaymentMethods();
    commit('setProperty', { property: 'payment_methods', payload: response });
  },

  /**
   *
   * @param commit
   * @param paymentMethodId
   * @returns {Promise<void>}
   */
  async deletePaymentMethod({ commit }, { paymentMethodId }) {
    await deletePaymentMethod(paymentMethodId);
    commit('delProperty', { property: paymentMethodId });
  },

  /**
   *
   * @param context
   * @param paymentMethodId
   * @param paymentMethod
   * @returns {Promise<void>}
   */
  async updatePaymentMethod(context, { paymentMethodId, paymentMethod }) {
    await updatePaymentMethod(paymentMethodId, paymentMethod);
  },

  /**
   *
   * @param context
   * @param paymentMethod
   * @returns {Promise<void>}
   */
  async newPaymentMethod({ commit }, { paymentMethod }) {
    const response = await newPaymentMethod(paymentMethod);
    commit('setNewPaymentMethod', { payload: response });
  },
};
